import { styled } from "@mui/material/styles"

import Column from "./Column"

export default styled(Column)(({ theme }) => ({
  background: theme.palette.colors.dimBackground,
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
  position: "relative",
}))
